import _objectWithoutProperties from "/home/maxwell/maxwell-sms-shopify-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { classNames } from '../../utilities/css.js';
import styles from './Page.scss.js';
import { Header } from './components/Header/Header.js';

function Page(_ref) {
  var children = _ref.children,
      fullWidth = _ref.fullWidth,
      narrowWidth = _ref.narrowWidth,
      divider = _ref.divider,
      rest = _objectWithoutProperties(_ref, ["children", "fullWidth", "narrowWidth", "divider"]);

  var pageClassName = classNames(styles.Page, fullWidth && styles.fullWidth, narrowWidth && styles.narrowWidth);
  var hasHeaderContent = rest.title != null && rest.title !== '' || rest.primaryAction != null || rest.secondaryActions != null && rest.secondaryActions.length > 0 || rest.actionGroups != null && rest.actionGroups.length > 0 || rest.breadcrumbs != null && rest.breadcrumbs.length > 0;
  var contentClassName = classNames(styles.Content, divider && hasHeaderContent && styles.divider);
  var headerMarkup = hasHeaderContent ?
  /*#__PURE__*/
  React.createElement(Header, rest) : null;
  return (
    /*#__PURE__*/
    React.createElement("div", {
      className: pageClassName
    }, headerMarkup,
    /*#__PURE__*/
    React.createElement("div", {
      className: contentClassName
    }, children))
  );
}

export { Page };